
module.exports = {
	NotificationStatus:
	{
		"onUndefined": 0,
		"onInternetError": 1,
		"onSignalRError": 2,
		"onConnectSuccess": 11,
		"onConnectFailed": 12,
		"onReconnectSuccess": 13,
		"onReconnectFailed": 14,
		"onGetConfig": 15,
		"onNotifyJoin": 20, // some connection join group
		"onNotifyLeave": 21, // sone connection leave group
		"onAction": 22,
		"onResponseGroupInfo": 30, // acquire all connection info in group
		"onSendHeartbeatTriggered": 40, //發送心跳包
		"onSendHeartbeatSuccess": 41,//發送心跳包成功
		"onSendHeartbeatFault": 42,//發送心跳包失敗
		"onConnectionStatus": 43//遙控端心跳包 但表client端還活著
	},
	RequestAction: "Request",
	ResponseAction: "Response",
	WinLobbyGuard: "WinLobbyGuard",
	WinLobbyClient: "WinLobbyClient",
	WinLobbyManager: "WinLobbyManager",
	WinLobbyAll: "WinLobbyAll"
};